module.exports = __webpack_public_path__ + "media/images/hezbollah-bg-section-3-da36dec4740919bdb2542de9d491b576.png";